import mapStylesFactory from '@/components/map/MapStylesFactory'

export const black = mapStylesFactory()
export const white = mapStylesFactory({
    fillColor:'rgba(255,255,255,1)',
    lineColor:'rgba(200,200,200,1)'
})
export const yellow = mapStylesFactory({
    fillColor:'#fcc419',
    lineColor:'#ffd43b'
})
export const orange = mapStylesFactory({
    fillColor:'#f76707',
    lineColor:'#fd7e14'
})
export const red = mapStylesFactory({
    fillColor:'#f03e3e',
    lineColor:'#fa5252'
})
export const purple = mapStylesFactory({
    fillColor:'#ae3ec9',
    lineColor:'#be4bdb'
})
export const blue = mapStylesFactory({
    fillColor:'#228be6',
    lineColor:'#339af0'
})
export const green = mapStylesFactory({
    fillColor:'#40c057',
    lineColor:'#51cf66'
})

export const defaultMapStyle = { name : "Default", color:'rgba(0,0,0,0)' , fct : false}

export const stylesList = [
    defaultMapStyle,
    { name : "Black", color:'#000000' , fct : black},
    { name : "White", color:'#ffffff' , fct : white},
    { name : "Yellow", color:'#fcc419' , fct : yellow},
    { name : "Orange", color:'#f76707' , fct : orange},
    { name : "Red", color:'#f03e3e' , fct : red},
    { name : "Purple", color:'#ae3ec9' , fct : purple},
    { name : "Blue", color:'#228be6' , fct : blue},
    { name : "Green", color:'#40c057' , fct : green},
]



